/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Custom serializer for password reset view.
 * @export
 * @interface PasswordReset
 */
export interface PasswordReset {
    /**
     * 
     * @type {string}
     * @memberof PasswordReset
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordReset
     */
    resetToken?: string;
}

/**
 * Check if a given object implements the PasswordReset interface.
 */
export function instanceOfPasswordReset(value: object): value is PasswordReset {
    return true;
}

export function PasswordResetFromJSON(json: any): PasswordReset {
    return PasswordResetFromJSONTyped(json, false);
}

export function PasswordResetFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordReset {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'resetToken': json['reset_token'] == null ? undefined : json['reset_token'],
    };
}

export function PasswordResetToJSON(json: any): PasswordReset {
    return PasswordResetToJSONTyped(json, false);
}

export function PasswordResetToJSONTyped(value?: PasswordReset | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'reset_token': value['resetToken'],
    };
}

